import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  Tag,
} from '@griply/types';

export const getTagDefaultFilterDocument = (tag?: Tag): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.Tag]: { include: [tag?.id ?? ''] },
  },
});
